// Case 360° (Lot 2) Stage 8 — LEO Reference (Legal Entities & Organizations).
// Minimal confirmed field set; the Q2 extension (region/code/email + extra
// types) is client-pending.

export type LeoType = 'COURT' | 'GOVERNMENT_BODY' | 'NOTARY';
export type LeoStatus = 'DRAFT' | 'VERIFIED';

export const LEO_TYPE_VALUES: LeoType[] = ['COURT', 'GOVERNMENT_BODY', 'NOTARY'];

export interface LeoEntry {
  id: number;
  name: string;
  type: LeoType;
  city: string;
  address?: string | null | undefined;
  phone?: string | null | undefined;
  notes?: string | null | undefined;
  status: LeoStatus;
  createdById?: number | null | undefined;
  createdAt: string;
  updatedAt?: string | undefined;
  deletedAt?: string | null | undefined;
}

export interface CreateLeoDto {
  name: string;
  type: LeoType;
  city: string;
  address?: string | undefined;
  phone?: string | undefined;
  notes?: string | undefined;
  /** Acknowledge a fuzzy-duplicate warning (80–94%); a block can't be forced. */
  force?: boolean | undefined;
}

export type UpdateLeoDto = Partial<Omit<CreateLeoDto, 'force'>>;

export interface LeoFilters {
  s?: string | undefined;
  type?: LeoType | undefined;
  status?: LeoStatus | undefined;
  includeArchived?: boolean | undefined;
  limit?: number | undefined;
  page?: number | undefined;
  [key: string]: unknown;
}

export interface LeoListResponse {
  results: LeoEntry[];
  total: number;
}

export type DuplicateLevel = 'ok' | 'warning' | 'block';

export interface DuplicateMatch {
  id: number;
  name: string;
  city: string;
  status: LeoStatus;
  similarity: number; // 0..1
  sameCity: boolean;
}

export interface DuplicateCheckResult {
  level: DuplicateLevel;
  matches: DuplicateMatch[];
}

export interface MergeLeoDto {
  sourceId: number;
  targetId: number;
  reason?: string | undefined;
}
